import {Component, OnInit, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {NavigationService} from '../../../Services/navigation.service';
import {DatePipe} from '@angular/common';
import {ResponseModel} from '../../../DataModels/response-model';

@Component({
  selector: 'app-timesheet-approval-form',
  templateUrl: './timesheet-approval-form.component.html',
  styleUrls: ['./timesheet-approval-form.component.css'],
  standalone: false
})
export class TimesheetApprovalFormComponent implements OnInit {
  vm: any = {
    title: $localize`:Timesheet Approval@@timesheetApproval:Timesheet Approval`,
    item: {},
    buttonsDisabled: false,
    Preferences: [],
    mainListPage: '/timesheet/timesheet-approval-list',
    formInitiated: false,
    timeEntries: [],
    timeEntriesLoaded: false,
  };

  timesheetId = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private datePipe: DatePipe,
    private titleService: Title,
    private nav: NavigationService,
    private destroyRef: DestroyRef,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle(this.vm.title);
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.dataInit();
  }

  dataInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.timesheetId = params.id;
      if (this.timesheetId) {
        this.tableDataService.getData('pr_timesheet', this.timesheetId).subscribe({
          next: (result: any) => {
            this.vm.item = result;
            this.vm.item.pay_period_start = this.datePipe.transform(this.vm.item.pay_period_start, 'MM/dd/yyyy');
            this.vm.item.pay_period_end = this.datePipe.transform(this.vm.item.pay_period_end, 'MM/dd/yyyy');
            this.vm.formInitiated = true;
            this.loadTimeEntries();
          },
          error: (err) => {
            console.error(err);
            this.notification.showErrorToast($localize`:Error loading timesheet@@errorLoadingTimesheet:Error loading timesheet`);
          },
        });
      }
    });
  }

  loadTimeEntries() {
    if (!this.timesheetId) {
      return;
    }
    this.tableDataService.getApiListData('pr_time_entry', '?timesheet_id=' + this.timesheetId + '&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.vm.timeEntries = result.Data ?? [];
        this.vm.timeEntriesLoaded = true;
      },
      error: (err) => console.error(err),
    });
  }

  get entryTypeSummary(): { type: string; hours: number }[] {
    const entries: any[] = this.vm.timeEntries ?? [];
    const map = new Map<string, number>();
    for (const e of entries) {
      const type = e.entry_type ?? 'regular';
      map.set(type, (map.get(type) ?? 0) + (e.hours ?? 0));
    }
    return Array.from(map.entries()).map(([type, hours]) => ({type, hours}));
  }

  get totalHours(): number {
    return (this.vm.timeEntries ?? []).reduce((sum: number, e: any) => sum + (e.hours ?? 0), 0);
  }

  statusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'submitted':
        return 'bg-warning text-dark';
      case 'returned':
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  }

  onClose() {
    this.nav.backOr(this.vm.mainListPage);
  }

  approveTimesheet() {
    if (!this.vm.item.id || this.vm.buttonsDisabled) {
      return;
    }
    this.vm.buttonsDisabled = true;
    this.tableDataService.put('pr_timesheet/' + this.vm.item.id + '/approve', '', {}).subscribe({
      next: () => {
        this.vm.item.status = 'approved';
        this.notification.showSuccessToast($localize`:Approved@@approved:Approved`);
        this.vm.buttonsDisabled = false;
      },
      error: (err) => {
        this.vm.buttonsDisabled = false;
        console.error(err);
        this.notification.showErrorToast($localize`:Error approving timesheet@@errorApprovingTimesheet:Error approving timesheet`);
      },
    });
  }

  returnTimesheet() {
    if (!this.vm.item.id || this.vm.buttonsDisabled) {
      return;
    }
    this.vm.buttonsDisabled = true;
    this.tableDataService.put('pr_timesheet/' + this.vm.item.id + '/return', '', {}).subscribe({
      next: () => {
        this.vm.item.status = 'returned';
        this.notification.showSuccessToast($localize`:Returned@@returned:Returned`);
        this.vm.buttonsDisabled = false;
      },
      error: (err) => {
        this.vm.buttonsDisabled = false;
        console.error(err);
        this.notification.showErrorToast($localize`:Error returning timesheet@@errorReturningTimesheet:Error returning timesheet`);
      },
    });
  }
}
